import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useBasketStore } from "~/stores/basket";

export default defineNuxtRouteMiddleware((to) => {
  if (!useBasketStore().needsDeliveryLocation) return;

  return navigateTo(
    {
      name: "outlet",
      params: {
        orderingMode: to.params.orderingMode,
        outletSlug: to.params.outletSlug,
      },
    },
    { replace: true },
  );
});
